import React from 'react';
import {
  AreaChart,
  Area,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

// Custom Tooltip for Vulnerabilities
const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload || !payload.length) return null;

  const data = payload[0]?.payload || {};

  return (
    <div className="bg-gray-900/95 backdrop-blur-sm px-2 py-1 rounded shadow-xl border border-red-500/30 text-xs">
      <p className="text-gray-400 mb-1">{label}</p>
      <div className="grid grid-cols-2 gap-x-2 gap-y-0.5">
        <span className="text-red-400">C: {data.critical}</span>
        <span className="text-orange-400">H: {data.high}</span>
        <span className="text-yellow-400">M: {data.medium}</span>
        <span className="text-blue-400">L: {data.low}</span>
      </div>
    </div>
  );
};

const VulnMiniChart = ({ data }) => {
  // Default mock data for 7 days
  const defaultData = [
    { date: '24', critical: 2, high: 5, medium: 8, low: 10, total: 25 },
    { date: '25', critical: 3, high: 7, medium: 10, low: 12, total: 32 },
    { date: '26', critical: 1, high: 4, medium: 6, low: 8, total: 19 },
    { date: '27', critical: 4, high: 9, medium: 12, low: 15, total: 40 },
    { date: '28', critical: 2, high: 6, medium: 9, low: 11, total: 28 },
    { date: '29', critical: 3, high: 8, medium: 11, low: 13, total: 35 },
    { date: '30', critical: 4, high: 8, medium: 12, low: 11, total: 35 },
  ];

  const chartData = data || defaultData;

  return (
    <div className="w-full h-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={chartData}
          margin={{ top: 2, right: 2, bottom: 2, left: 2 }}
        >
          <defs>
            <linearGradient id="vulnGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#EF4444" stopOpacity={0.6} />
              <stop offset="30%" stopColor="#F97316" stopOpacity={0.4} />
              <stop offset="60%" stopColor="#EAB308" stopOpacity={0.2} />
              <stop offset="100%" stopColor="#7F1D1D" stopOpacity={0.1} />
            </linearGradient>
          </defs>

          <Area
            type="monotone"
            dataKey="total"
            stroke="#EF4444"
            strokeWidth={1.5}
            fill="url(#vulnGradient)"
            dot={false}
            activeDot={{
              r: 3,
              fill: '#EF4444',
              stroke: '#000',
              strokeWidth: 1,
            }}
            animationDuration={600}
          />

          <Tooltip
            content={<CustomTooltip />}
            cursor={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default VulnMiniChart;
